import styled from 'styled-components';
import { TYPE } from 'theme';
import { CardStyles, GradientBorderProps, GradientTextColor2, GradientBorder, AksharFont } from 'theme/commonStyles';


export const GradientBorderBox = styled.div<GradientBorderProps>`
    ${GradientBorder};
`;

export const GoldGradientBorderBox = styled(GradientBorderBox).attrs({
    gradient: 'linear-gradient(90deg, #fdb541 0%, #fcd763 31%, #f3eac4 63%, #f4b742 97%)',
    borderRadius: 8,
})`
    padding: 4px 8px;
`;

export const GoldGradientText = styled(TYPE.desc)`
    ${GradientTextColor2}
    display: inline-block;
`;

interface GradientShadowBoxProps {
    background?: string;
    top?: number;
    left?: number;
    right?: number;
    bottom?: number;
    height?: number;
    width?: number;
    blur?: number;
    borderRadius?: number;
}

export const GradientShadowBox = styled.div<GradientShadowBoxProps>`
    position: relative;
    background: transparent;
    /* border-radius: ${({ borderRadius }) => borderRadius || '100%'}; */
    &::before {
        content: '';
        position: absolute;
        top: ${({ top }) => top && `${top}px`};
        left: ${({ left }) => left && `${left}px`};
        right: ${({ right }) => right && `${right}px`};
        bottom: ${({ bottom }) => bottom && `${bottom}px`};
        height: ${({ height }) => height && `${height}px`};
        width: ${({ width }) => width && `${width}px`};
        background: ${({ background, theme }) => background || `linear-gradient(90deg, ${theme.c.primary01}, ${theme.c.primary02});`};
        border-radius: ${({ borderRadius }) => borderRadius || '100%'};
        filter: ${({ blur }) => `blur(${blur || 20}px)`};
        z-index: -1;
    }
`;

export const StyledMainContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        margin: 0 16px;
    `};
`;

export const StyledCard = styled.div`
    ${CardStyles}
`;

export const BlurredBox = styled.div<{ blur?: number | boolean }>`
    filter: ${({ blur }) => (blur === false ? 'unset' : `blur(${Number(blur) || 8}px)`)};
    user-select: ${({ blur }) => (blur === false ? 'unset' : 'none')};
    pointer-events: ${({ blur }) => (blur === false ? 'unset' : 'none')};
`;

export const Bonus = styled.div<{ fontSize?: string }>`
    ${AksharFont}
    font-size: ${({ fontSize }) => fontSize};
    font-weight: 700;
    color: ${({ theme }) => theme.c.success};
`;
